import React, { useState } from "react";
import CoreH5 from "../dataDisplay/CoreH5";
import CoreButton from "./CoreButton";
import CoreTypographyBody1 from "../dataDisplay/CoreTypographyBody1";
import { Checkbox, FormControlLabel, Icon } from "@mui/material";
import { theme } from "../../config/theme";
import CoreIconButton from "./CoreIconButton";
import { useSelector } from "react-redux";

export default function CoreFileUploader({
  handleChange,
  noText = false,
  noImage = false,
  size = 185,
  tool,
  allowedFiles = ["jpg", "jpeg", "png", "zip", "pdf"],
  isMulti = false,
  onMultiChange,
  isMultiChecked,
  customHelperText = null,
  label,
}) {
  const toolDocs = useSelector((state) => state.common.toolDocs);
  const [dragging, setDragging] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);

  const handleDragOver = (event) => {
    event.preventDefault();
    setDragging(true);
  };

  const handleDragLeave = () => {
    setDragging(false);
  };

  const handleUpload = (event) => {
    event.preventDefault();
    const file = event?.target?.files[0];
    const fileFormat =
      file?.name?.split(".")[file?.name?.split(".").length - 1];
    if (!allowedFiles.includes(fileFormat?.toLowerCase())) {
      alert(
        "File type not supported Only " +
          allowedFiles?.join(", ") +
          " files are supported. submitted " +
          fileFormat?.toLowerCase(),
      );
      return;
    }
    if (file) {
      setUploadedFile(file);
      handleChange(file);
    }
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setDragging(false);
    const file = event.dataTransfer.files[0];
    const fileFormat =
      file?.name?.split(".")[file?.name?.split(".").length - 1];
    if (!allowedFiles.includes(fileFormat?.toLowerCase())) {
      alert(
        "File type not supported Only" +
          allowedFiles?.join(", ") +
          "files are supported. submitted " +
          fileFormat?.toLowerCase(),
      );
      return;
    }
    if (file) {
      setUploadedFile(file);
      handleChange(file);
    }
  };

  console.log("dragging", uploadedFile);

  return (
    <div
      style={{
        backgroundColor: dragging
          ? theme.palette.secondary.light
          : theme.palette.background.paper,
        height: "100%",
        width: "100%",
      }}
    >
      <div className="row" style={{ height: "100%", width: "100%" }}>
        <div className="col s12" style={{ height: "100%", width: "100%" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              padding: "20px",
              borderRadius: "10px",
              textAlign: "center",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              width: "100%",
            }}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
          >
            {!noImage && (
              <Icon
                style={{
                  fontSize: size,
                  color: theme.palette.secondary.light,
                }}
              >
                cloud_upload
              </Icon>
            )}
            {uploadedFile ? (
              <div style={{ display: "flex" }}>
                <p>Uploaded File: {uploadedFile.name}</p>
                <CoreIconButton
                  onClick={() => {
                    setUploadedFile(null);
                  }}
                >
                  <Icon
                    style={{
                      color: dragging
                        ? theme.palette.error.main
                        : theme.palette.error.dark,
                    }}
                  >
                    cancel
                  </Icon>
                </CoreIconButton>
              </div>
            ) : (
              <>
                <CoreH5>
                  Drop files here or{""}
                  <label style={{ cursor: "pointer", fontSize: "18px" }}>
                    <CoreButton
                      variant="text"
                      component="span"
                      style={{ fontSize: "18px" }}
                    >
                      Upload
                    </CoreButton>
                    <input
                      type="file"
                      style={{ display: "none" }}
                      onChange={handleUpload}
                    />
                  </label>
                </CoreH5>

                {!noText && (
                  <>
                    {customHelperText ? (
                      <CoreTypographyBody1 style={{ maxWidth: "70%" }}>
                        {customHelperText}
                      </CoreTypographyBody1>
                    ) : (
                      <CoreTypographyBody1 style={{ maxWidth: "70%" }}>
                        {label ||
                          `Supported documents: Single file or a zip file with image(s) or PDF(s) of `}
                        {toolDocs &&
                          toolDocs[tool] &&
                          toolDocs[tool]?.map((docType, index) =>
                            index < toolDocs[tool].length - 1 ? (
                              <CoreTypographyBody1 component="span">
                                {docType.label + ", "}
                              </CoreTypographyBody1>
                            ) : (
                              <CoreTypographyBody1 component="span">
                                {docType.label}
                              </CoreTypographyBody1>
                            ),
                          )}
                      </CoreTypographyBody1>
                    )}
                  </>
                )}

                {isMulti && (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isMultiChecked}
                        onChange={onMultiChange}
                      />
                    }
                    color=" "
                    label="Please check here if you are uploading a combined file with multiple documents"
                  />
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
